export const DEFAULT_LABOUR_CHARGE_POLICY = {
  loading: { capture: 'booking' },
  unloading: { capture: 'received' },
};

const STAGES = new Set(['off', 'booking', 'dispatch', 'received', 'delivery']);

export const normalizeLabourChargePolicy = (raw) => {
  const policy = {
    loading: { ...DEFAULT_LABOUR_CHARGE_POLICY.loading },
    unloading: { ...DEFAULT_LABOUR_CHARGE_POLICY.unloading },
  };
  if (!raw || typeof raw !== 'object') return policy;
  ['loading', 'unloading'].forEach((kind) => {
    const capture = String(raw[kind]?.capture || policy[kind].capture).trim().toLowerCase();
    if (STAGES.has(capture)) policy[kind] = { capture };
  });
  return policy;
};

export const LABOUR_CAPTURE_OPTIONS = [
  { value: 'booking', label: 'Add Shipment' },
  { value: 'dispatch', label: 'Dispatch / ML' },
  { value: 'received', label: 'Received' },
  { value: 'delivery', label: 'Delivered' },
  { value: 'off', label: 'Do not collect' },
];

export const LABOUR_WORKFLOWS = [
  {
    id: 'booking_then_received',
    title: 'Unload when goods arrive',
    loading: 'booking',
    unloading: 'received',
    hint: 'Enter loading on Add Shipment. Enter unloading on Update Status → Received.',
  },
  {
    id: 'both_booking',
    title: 'Collect both at booking',
    loading: 'booking',
    unloading: 'booking',
    hint: 'Enter loading and unloading on Add Shipment. Receiver still keeps unloading.',
  },
];

export const labourWorkflowId = (policy) => {
  const n = normalizeLabourChargePolicy(policy);
  const match = LABOUR_WORKFLOWS.find(
    (w) => w.loading === n.loading.capture && w.unloading === n.unloading.capture,
  );
  return match?.id || 'custom';
};

export const labourCapturedAt = (policy, kind, stage) =>
  String(normalizeLabourChargePolicy(policy)[kind]?.capture) === String(stage);

/** Status-update page: default still shows unload on Received for agent hubs. */
export const showLabourOnStatus = (policy, kind, selectedStatus, { agentHub = false, chargeEnabled = false } = {}) => {
  const capture = normalizeLabourChargePolicy(policy)[kind]?.capture;
  const status = String(selectedStatus || '');
  const statusMatch =
    (capture === 'received' && status === 'Received')
    || (capture === 'delivery' && status === 'Delivered');
  if (!statusMatch) return false;
  if (kind === 'unloading' && capture === 'received' && agentHub) return true;
  return !!chargeEnabled || (kind === 'unloading' && agentHub);
};
